export const MEDIA_CDN_URL = 'https://web-media-files.lstprod.net/MK_Replays/';

export const VIDEO = new Map<string, string>([
  ['bg_mobile', 'rework_Mob_steam_webm2.webm'],
  ['bg_fhd', 'FullHD_steam_webm.webm'],
  ['bg_4k', 'rework_4k_steam_webm.webm'],
]);
